import React from 'react';
import { siteData, navLinks } from '../data';

export default function Footer() {
  return (
    <footer style={{background:'#050508',borderTop:'1px solid rgba(200,168,75,0.12)'}}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
               <div className="w-10 h-10 rounded-sm flex items-center justify-center font-black font-mono text-sm text-black">

                 <img src="/images/logos/mainlogo.png" className="w-full h-full object-contain" alt="ITS Academy Logo" />
               </div>
               
               
              <div>
                <div className="font-black text-xl text-white" style={{fontFamily:'Playfair Display,serif'}}>ITS <span style={{color:'#C8A84B'}}>Academy</span></div>
                <div style={{fontSize:'0.65rem',letterSpacing:'2px',color:'rgba(212,207,197,0.35)',textTransform:'uppercase'}}>Saharanpur · Est. 2001</div>
              </div>
            </div>
            <p style={{color:'rgba(212,207,197,0.45)',fontSize:'0.82rem',lineHeight:'1.8',marginBottom:'16px'}}>
              Saharanpur's most trusted computer education centre for 24+ years. NIELIT affiliated, government recognized.
            </p>
            {/* <div className="flex gap-2">
              {['⭐','📘','📸','▶️'].map((icon, i) => (
                <a key={i} href="#" className="w-8 h-8 flex items-center justify-center rounded-sm text-sm transition-all duration-300 hover:scale-110"
                  style={{background:'rgba(200,168,75,0.08)',border:'1px solid rgba(200,168,75,0.15)'}}>
                  {icon}
                </a>
              ))}
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{color:'white',fontWeight:'700',marginBottom:'16px',fontSize:'0.9rem',letterSpacing:'1px',textTransform:'uppercase'}}>Quick Links</h4>
            <ul className="space-y-2">
              {navLinks.map(link => (
                <li key={link.href}>
                  <a href={link.href} className="transition-colors duration-300 text-sm hover:text-yellow-400"
                    style={{color:'rgba(212,207,197,0.45)',textDecoration:'none'}}>
                    → {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{color:'white',fontWeight:'700',marginBottom:'16px',fontSize:'0.9rem',letterSpacing:'1px',textTransform:'uppercase'}}>Contact</h4>
            <div className="space-y-3" style={{fontSize:'0.82rem',color:'rgba(212,207,197,0.5)',lineHeight:'1.6'}}>
              <div><span style={{color:'#C8A84B'}}>📍</span> {siteData.headOffice}</div>
              {siteData.phone.map(p => (
                <div key={p}><span style={{color:'#C8A84B'}}>📞</span> <a href={`tel:${p.replace(/\s/g,'')}`} style={{color:'inherit',textDecoration:'none'}} className="hover:text-yellow-400 transition-colors">{p}</a></div>
              ))}
              <div><span style={{color:'#C8A84B'}}>✉️</span> <a href={`mailto:${siteData.email}`} style={{color:'inherit',textDecoration:'none'}} className="hover:text-yellow-400 transition-colors">{siteData.email}</a></div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{borderTop:'1px solid rgba(200,168,75,0.08)',paddingTop:'24px',display:'flex',flexWrap:'wrap',gap:'12px',justifyContent:'space-between',alignItems:'center'}}>
          <p style={{color:'rgba(212,207,197,0.25)',fontSize:'0.75rem'}}>
            © {new Date().getFullYear()} ITS Academy Computer Education Centre, Saharanpur. All Rights Reserved.
          </p>
          <div className="flex gap-4">
            {['Privacy Policy','Terms & Conditions','Sitemap'].map(l => (
              <a key={l} href="#" style={{color:'rgba(212,207,197,0.25)',fontSize:'0.72rem',textDecoration:'none'}} className="hover:text-yellow-400 transition-colors">{l}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
